export enum ProfileSource {
  NamedResource = "named-resource",
  Shortlist = "shortlist",
  Matches = "matches"
}
